import axios from '../localAxios';
import { studentScoreURL } from './studentScoreURL';

export async function deleteStudentScore({
  questionScoreId,
  studentId,
  isRostered,
}: {
  questionScoreId: number;
  studentId: number;
  isRostered: boolean;
}) {
  const url = studentScoreURL({ questionScoreId, studentId, isRostered });
  const { data } = await axios.delete<unknown>(url.href);
  return data;
}
